<p-confirmdialog #cd [style]="{width: '50vw'}" [transitionOptions]="'0ms'"
    [breakpoints]="{'960px': '75vw', '640px': '100vw'}">
    <ng-template pTemplate="header">
        <h3>{{'components.global.confirmDialog.title' | translate}}</h3>
    </ng-template>
    <ng-template pTemplate="footer">
        <button type="button" pButton icon="pi pi-times" [label]="'labels.nao' | translate"
            class="p-button-danger p-button-outlined" (click)="cd.reject(); cd.hide();"></button>
        <button type="button" pButton icon="pi pi-check" [label]="'labels.sim' | translate"
            (click)="cd.accept(); cd.hide();"></button>
    </ng-template>
</p-confirmdialog>